import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <section className="not-found">
      <h1 className="not-found__title">404</h1>
      <p className="not-found__subtitle">Страница не найдена</p>
      <Link className="note-found__link" to="/">
        На главную
      </Link>
    </section>
  );
};

export default PageNotFound;
